import { useState, useCallback } from "react";
import { authApi } from "../api";
import type { LoginRequest, CreateMemberRequest } from "../api/auth";

interface AuthState {
  isLoading: boolean;
  error: string | null;
  isAdmin: boolean;
}

export const useAuth = () => {
  const [state, setState] = useState<AuthState>({
    isLoading: false,
    error: null,
    isAdmin: localStorage.getItem("isAdmin") === "true",
  });

  const login = useCallback(
    async (body: LoginRequest): Promise<{ ok: boolean; isAdmin: boolean }> => {
      setState((s) => ({ ...s, isLoading: true, error: null }));
      try {
        const { access_token, admin_flg } = await authApi.login(body);
        localStorage.setItem("token", access_token);
        localStorage.setItem("isAdmin", String(admin_flg));
        setState((s) => ({ ...s, isLoading: false, isAdmin: admin_flg }));
        return { ok: true, isAdmin: admin_flg };
      } catch {
        setState((s) => ({
          ...s,
          isLoading: false,
          error: "ログインIDまたはパスワードが正しくありません",
        }));
        return { ok: false, isAdmin: false };
      }
    },
    []
  );

  const signUp = useCallback(
    async (body: CreateMemberRequest): Promise<boolean> => {
      setState((s) => ({ ...s, isLoading: true, error: null }));
      try {
        await authApi.signUp(body);
        setState((s) => ({ ...s, isLoading: false }));
        return true;
      } catch {
        setState((s) => ({
          ...s,
          isLoading: false,
          error: "アカウント作成に失敗しました",
        }));
        return false;
      }
    },
    []
  );

  const logout = useCallback(async () => {
    await authApi.logout();
    localStorage.removeItem("token");
    localStorage.removeItem("isAdmin");
    setState({ isLoading: false, error: null, isAdmin: false });
  }, []);

  return { ...state, login, signUp, logout };
};
